import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { MainSidebar, MobileDrawer } from "components/Sidebars";
import { Header, SignOutModal } from "components/UI";
import { useChurchStore } from "features/churches";
import { useUser } from "features/users";
import { useEffect } from "react";
import { useAuthUser, useSignOut } from "react-auth-kit";
import { Outlet, useNavigate } from "react-router-dom";

const Container = styled.div`
  display: flex;
  height: 100vh;
`;

const Sidebar = styled.div`
  display: none;

  ${({ theme }) => `${theme.breakpoints.up("md")} {
    display: block;
  }`}
`;

const Content = styled.div`
  height: 100vh;
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  ${({ theme }) => `${theme.breakpoints.up("md")} {
    flex-basis: 50%;
  }`}
`;

export function DashboardLayout({ sidebar = <MainSidebar /> }) {
  const navigate = useNavigate();
  const selectedChurch = useChurchStore(state => state.selectedChurch);
  const auth = useAuthUser();
  const signOut = useSignOut();

  useEffect(() => {
    if (!selectedChurch) {
      navigate("/churches");
    }
  }, [selectedChurch]);

  const userQuery = useUser({
    churchId: selectedChurch?.id,
    userId: auth()?.id
  });

  useEffect(() => {
    if (userQuery.data && !userQuery.data?.result?.account_users?.[0]?.status) {
      signOut();
    }
  }, [userQuery.data]);

  return (
    <Container>
      <SignOutModal />
      <MobileDrawer />
      <Sidebar>{sidebar}</Sidebar>
      <Content>
        <Header />
        <Box sx={{ background: "#F3F4F6" }}>
          <Outlet />
        </Box>
      </Content>
    </Container>
  );
}
